import React from 'react';
import { Dialog } from '@headlessui/react';

const ErrorModal = ({ isOpen, onClose, errorMessage }) => {
    return (
        <Dialog open={isOpen} onClose={onClose} className="fixed z-50 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen p-4">
                <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30 transition-opacity" />
                <Dialog.Panel className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-4">
                    <Dialog.Title className="text-xl font-semibold text-red-600 mb-4">
                        Error
                    </Dialog.Title>
                    <div className="mb-4 text-red-700">
                        {errorMessage}
                    </div>
                    <div className="flex justify-end">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
                        >
                            Close
                        </button>
                    </div>
                </Dialog.Panel>
            </div>
        </Dialog>
    );
};

export default ErrorModal;
